import React from "react";
import theme from "theme";
import { Theme } from "@quarkly/widgets";
import { Helmet } from "react-helmet";
import { GlobalQuarklyPageStyles } from "global-page-styles";
import { RawHtml } from "@quarkly/components";
export default (() => {
	return <Theme theme={theme}>
		<GlobalQuarklyPageStyles pageUrl={"404"} />
		<Helmet>
			<title>
				IA - Сервис защиты фьючерсных позиций
			</title>
			<meta name={"description"} content={"IndexAny.com - Сервис для трейдеров на криптовалютных биржах, который поможет защитить ваш фьючерсный баланс от опасных просадок."} />
			<meta property={"og:description"} content={"IndexAny.com - Сервис для трейдеров на криптовалютных биржах, который поможет защитить ваш фьючерсный баланс от опасных просадок."} />
			<link rel={"shortcut icon"} href={"https://uploads.quarkly.io/readme/cra/favicon-32x32.ico"} type={"image/x-icon"} />
		</Helmet>
		<RawHtml>
			<style place={"endOfHead"} rawKey={"6686aea51d712a002335db86"}>
				{":root {\n  box-sizing: border-box;\n}\n\n* {\n  box-sizing: inherit;\n}"}
			</style>
		</RawHtml>
	</Theme>;
});